// extracted by mini-css-extract-plugin
export default {"menu":"MainLayout_menu__nYCoW","layout-content":"MainLayout_layout-content__e7Jvv","button-lang":"MainLayout_button-lang__EqSRA"};